// import {
//   Box,
// } from '@chakra-ui/react';
// import { useParams } from 'react-router-dom';
// import { SocialSidebar } from '../components/SocialSideBar';

// export default function InboxPage({ }) {
//   let {orgId} = useParams();

//   return (
//     <Box
//       // boxShadow="lg"
//     >
//       <SocialSidebar />
//     </Box>
//   );
// }

import React, { useEffect, useState, ComponentType } from "react";
import {
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Icon,
  IconProps,
  Divider,
  Collapse,
  useColorModeValue,
  useDisclosure,
  SimpleGrid,
} from "@chakra-ui/react";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { useNavigate, useParams } from "react-router-dom";
import { getWANumber } from "../hooks/whatsapp";
import { getFacebookProfile } from "../hooks/facebook";
import { getInstagramUserProfile } from "../hooks/instagram";
import { getEmailAccount } from "../hooks/email";

export default function InboxPage() {
  const { orgId } = useParams();
  const navigate = useNavigate();

  const [whatsappNumber, setWhatsappNumber] = useState<any>();
  const [instagramAccId, setInstagramAccId] = useState<any>();
  const [facebookAccId, setFacebookAccId] = useState<any>();
  const [emailAcc, setEmailAcc] = useState<any>();
  const [expanded, setExpanded] = useState<string | null>(null);

  const bgHover = useColorModeValue("gray.100", "gray.700");
  const subItemHover = useColorModeValue("gray.200", "gray.600");

  const loadInit = async () => {
    const waResult = await getWANumber(orgId);
    if (waResult.success) setWhatsappNumber(waResult.data);

    const instaResult = await getInstagramUserProfile(orgId);
    if (instaResult.success)
      setInstagramAccId(
        Array.isArray(instaResult.data) && instaResult.data.length > 0
          ? instaResult.data[0]
          : null,
      );

    const fbResult = await getFacebookProfile(orgId);
    if (fbResult.success && fbResult.data.length > 0)
      setFacebookAccId(fbResult.data);

    const emailResult = await getEmailAccount(orgId);
    if (emailResult.success && emailResult.data.length > 0)
      setEmailAcc(emailResult.data);
  };

  useEffect(() => {
    loadInit();
  }, []);

  const toggle = (name: string) => {
    setExpanded(expanded === name ? null : name);
  };

  const socialPlatforms = [
    {
      name: "Facebook",
      icon: FaFacebookF,
      connected: !!facebookAccId,
      subItems: [
        { label: "Manage Messages", link: `/organization/${orgId}/inbox/facebook/conversations` },
        { label: "Manage Comments", link: `/organization/${orgId}/inbox/facebook/${facebookAccId?.[0]?.id || ''}/comments` },
      ],
      connectLink: `/organization/inbox/facebook-messenger`,
      color: "#1877F2",
    },
    {
      name: "Instagram",
      icon: FaInstagram,
      connected: !!instagramAccId,
      subItems: [
        { label: "Manage Messages", link: `/organization/${orgId}/inbox/instagram/conversations` },
        { label: "Manage Comments", link: `/organization/${orgId}/inbox/instagram/${instagramAccId?.id || ''}/comments` },
        { label: "Settings", link: `/organization/${orgId}/inbox/instagram/${instagramAccId?.id || ''}/settings` },
      ],
      connectLink: `/organization/inbox/instagram`,
      color: "#E1306C",
    },
    {
      name: "WhatsApp",
      icon: FaWhatsapp,
      connected: !!whatsappNumber,
      subItems: [
        { label: "Manage Messages", link: `/organization/${orgId}/inbox/whatsapp/conversations` },
        { label: "Manage Settings", link: `/organization/${orgId}/inbox/whatsapp/settings` },
      ],
      connectLink: `/organization/whatsapp`,
      color: "#25D366",
    },
  ];

  return (
    <Box
      p={6}
      bg={useColorModeValue("gray.50", "gray.900")}
      minH="100vh"
    >
      <Text fontSize="2xl" fontWeight="bold" mb={6}>
        Inbox
      </Text>

      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 3 }}
        spacing={6}
        alignItems="stretch"
      >
        {socialPlatforms.map((platform) => (
          <Box
            key={platform.name}
            bg={"white"}
            p={6}
            borderWidth="1px"
            borderColor={"gray.200"}
            rounded="xl"
            boxShadow="md"
            textAlign="center"
            _hover={{ transform: "translateY(-3px)", boxShadow: "lg" }}
            transition="all 0.2s"
          >
            <VStack spacing={4}>
              <Icon
                as={platform.icon as ComponentType<IconProps>}
                boxSize={{ base: 12, md: 10 }}
                color={platform.color}
              />
              <Text fontSize="lg" fontWeight="semibold">
                {platform.name}
              </Text>

              {platform.connected ? (
                <>
                  <Button
                    colorScheme="blue"
                    variant="solid"
                    w="full"
                    onClick={() => toggle(platform.name)}
                  >
                    {expanded === platform.name ? "Hide Options" : "Manage Inbox"}
                  </Button>

                  <Collapse in={expanded === platform.name} animateOpacity>
                    <VStack align="stretch" spacing={2} mt={3}>
                      {platform.subItems.map((item) => (
                        <Button
                          key={item.label}
                          variant="outline"
                          onClick={() => navigate(item.link)}
                        >
                          {item.label}
                        </Button>
                      ))}
                    </VStack>
                  </Collapse>
                </>
              ) : (
                <Button
                  colorScheme="teal"
                  variant="solid"
                  w="full"
                  onClick={() => navigate(platform.connectLink)}
                >
                  Connect Account
                </Button>
              )}
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
}
